import { UPDATE_VERSION } from './constants';

export function updateVersion(version) {
  return {
    type: UPDATE_VERSION,
    version,
  };
}
